var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsfeedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88867 8L10.89 1.99867L16.8913 8H16.89V18H4.89001V8H4.88867ZM2.89001 9.99866L1.4132 11.4755L0 10.0623L9.47699 0.58529C10.2574 -0.195097 11.5226 -0.195097 12.303 0.58529L21.78 10.0623L20.3668 11.4755L18.89 9.99869V18C18.89 19.1046 17.9946 20 16.89 20H4.89001C3.78545 20 2.89001 19.1046 2.89001 18V9.99866Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsfeedIcon);
export default __webpack_public_path__ + "static/media/newsfeed_icon.5fd42218.svg";
export { ForwardRef as ReactComponent };